import { defaultTableRowRenderer, TableRowProps } from "react-virtualized";
import { ROLES } from "@pacerpro/utils";

const supportRowRenderer = (
  role: string,
  { className, rowData, onRowClick, ...rest }: TableRowProps,
) => {
  const rowRole = rowData.attributes.role;
  const disableRow = () => {
    if (role === ROLES.MEMBER || rowRole === ROLES.MEMBER) return true;
    if (role === ROLES.ATTORNEY && rowRole === ROLES.ATTORNEY) {
      return true;
    }
    if (role !== ROLES.ATTORNEY && rowRole !== ROLES.ATTORNEY) {
      return true;
    }
    return false;
  };
  return defaultTableRowRenderer({
    className: `${className} ${disableRow() ? "disable_row" : ""}`,
    rowData,
    onRowClick: disableRow() ? undefined : onRowClick,
    ...rest,
  });
};

export default supportRowRenderer;
